<template>
    <div class="kings__student">
        <div class="kings__student-headers row">
            <div class="col-6 col-md-8">
                King's Student Optional Fees
            </div>
            <div class="col-3 col-md-2">
                Value
            </div>
            <div class="col-3 col-md-2">
                Opt-Out
            </div>
        </div>
        <div class="kings__student-fees">
            <div class="row" :class="[{ 'opt__out' : studentEndowment.optOut }]">
                <div class="col-6 col-md-8">
                    Student Endowment
                    <!-- <div v-if="!admin" class="fee__info">In agreement with KUCSC, this voluntary student donation will
                        support the
                        acquisition, restoration and maintenance of the property and buildings known as the St. Peter’s
                        Seminary Lands The campus development of the land will be a long-term project, with the input of
                        students, faculty, staff, Campus Ministry, Indigenous partners, and the broader London
                        community.
                        The initial phase includes dedicated athletic and recreation spaces to be utilized by King’s
                        students. New projects to include an amphitheater and recreation field.
                    </div> -->
                    <div v-if="!admin" class="fee__info">
                        The endowment fee provides financial support for King’s highest priority needs, ensuring stability and growth for future generations. 
                        This fee helps fund initiatives like student financial aid, new construction, and infrastructure improvements, enhancing both the academic and campus life experience.
                    </div>
                </div>
                <div class="col-3 col-md-2">
                    $ {{ studentEndowment.amount }}
                </div>
                <div class="col-3 col-md-2">
                    <div class="form-check">
                        <input type="checkbox" id="kings-studentendowment" name="kings-studentendowment"
                            v-model="studentEndowment.optOut" @change="optOut(studentEndowment)" value="opt-out"
                            aria-label="student endowment" :disabled="submitted">
                    </div>
                </div>
            </div>
        </div>
        <div :class="[total > 0 ? 'kings__student-fee' : 'kings__student-nofee', 'kings__student-total']">
            <div class="row">
                <div class="col-6 col-md-8">
                    Total King's Student Optional Fees
                </div>
                <div class="col-6 col-md-4">
                    $ {{ total }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'form-kings-student',
    props: {
        admin: {
            type: Boolean
        },
        userData: {
            type: Object
        },
        submitted: {
            type: Boolean
        }
    },
    data() {
        return {
            studentEndowment: {
                amount: "20.00",
                optOut: false
            },
            total: "0.00"
        }
    },
    methods: {
        optOut(fee) {
            // Opt-out calculation
            if (!fee.optOut) {
                this.total = Number.parseFloat(this.total) + Number.parseFloat(fee.amount);
            } else {
                this.total = Number.parseFloat(this.total) - Number.parseFloat(fee.amount);
            }

            // Currency parse and format
            this.total = Number.parseFloat(this.total).toFixed(2);

            // Update sci total fees
            this.$emit('getKingsStudentTotal', this.total);
        },
        getFee(fee) {
            // Student Endowment
            if (fee.match(/studentEndowment/i)) {
                return this.studentEndowment;
            } else {
                return false;
            }
        },
        getTotalFees() {
            // Total float calculation
            this.total = Number.parseFloat(this.studentEndowment.amount).toFixed(2);
        }
    },
    created() {
        // Total King's Student Optional Fees
        this.getTotalFees();

        // Update sci total fees
        this.$emit('getKingsStudentTotal', this.total);

        // Formdata handler
        if (this.userData.result && this.userData.result.match(/^OK/i)) {
            if (this.userData.data && this.userData.data.length > 0) {
                let formData = this.userData.data;

                formData.forEach((record) => {
                    let key = record.key;
                    let fee = this.getFee(key);

                    if (fee) {
                        fee.optOut = true;
                        this.optOut(fee);
                    }
                })
            }
        }
    }
}
</script>

<style>
.kings__student {
    margin-bottom: 1.25rem;
}

.kings__student-fees {
    border-bottom: 1px solid black;
    padding-bottom: .5rem;
}

.kings__student-headers {
    font-weight: 600;
    font-size: 16px;
}

.kings__student-total {
    font-weight: 600;
    font-size: 16px;
}

.kings__student-fee {
    color: #3455db;
}

.kings__student-nofee {
    color: #008040;
}
</style>
